import { useState } from "react";
import { atualizarArquivoService } from "../../../services/atualizarArquivoService";
import { ArquivosCotaUsuario } from "../../../interfaces/ArquivosCotaUsuario";

export const useAtualizarArquivo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState<string | null>("");
  const [error, setError] = useState<string | null>("");

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const atualizarArquivo = async (
    arquivoCotaUsuarioId: number,
    podeExcluir: number
  ) => {
    let formData: Partial<ArquivosCotaUsuario> = {};
    try {
      if (podeExcluir) {
        formData = {
          podeExcluir: false,
        };
        const data = await atualizarArquivoService(
          arquivoCotaUsuarioId,
          formData
        );
        if (data) {
          setSuccess("Arquivo bloqueado para exclusão com sucesso!");
          return true;
        } else {
          setError("Arquivo não encontrado ou não pode ser excluído. ");
          return false;
        }
      } else {
        setError(
          "Esse arquivo já está bloqueado para exclusão. Caso queira desbloquear fale com administrador."
        );
        return false;
      }
    } catch (error) {
      console.error("Erro ao baixar Arquivo:", error);
      setError("Arquivo não encontrado ou não pode ser excluído. ");
      return error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    atualizarArquivo,
    success,
    error,
    resetError,
    resetSuccess,
    isLoading,
  };
};
